import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Jeff Anders
 * id E1AF54E0-A2C9-41D4-89E0-62CD301F4B71
 * name checkbook-arrow-left
 * version: 7.2.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/checkbook-arrow-left.svg
 * tags
 * - Banking 
 */
export const CheckbookArrowLeftIcon = createSvgIcon(<><path d="M5 14H15.53C15.25 14.31 15 14.64 14.8 15H5V14M21 8V12.08C21.72 12.2 22.39 12.45 23 12.8V5H1V19H14.08C14.03 18.68 14 18.34 14 18C14 17.66 14.03 17.33 14.08 17H3V8H21M5 10H12V12H5V10M16 18L19 15V17H23V19H19V21L16 18Z" /></>, 'CheckbookArrowLeftIcon');
export default CheckbookArrowLeftIcon